'use client';

import React from 'react';
import { useRouter } from 'nextjs-toploader/app';
import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Button from '@/common/components/button/button.component';
import { PopUpModal } from '@/common/components/modal/popupModal.component';
import { createQueryStringUtility } from '@/common/utils/create-query-string.utility';

interface AuthModalProps {
  open: boolean;
  onCancel: () => void;
}

function AuthModal({ open, onCancel }: AuthModalProps) {
  const router = useRouter();

  const handleAuthRoute = () => {
    router.push(
      `/register${createQueryStringUtility({ redirect: '/profile/?from=cart' })}`
    );
  };
  return (
    <div className="hidden lg:block">
      <PopUpModal
        className="p- hidden lg:block"
        onCancel={onCancel}
        open={open}
        width={520}
      >
        <div className="p-6">
          <p className="text-[20px] font-semibold text-black-default">
            وارد حساب کاربری‌تون نشدین!{' '}
          </p>

          <p className="mt-4 w-full  text-justify text-base text-black-default ">
            برای تکمیل فرایند خرید، اول باید وارد حساب‌ کاربری‌تون بشین.{' '}
          </p>

          <div className="mt-9 flex w-full flex-row gap-y-3 ">
            <AnalyticsWrapper analytics={['checkout-click-login-v1']}>
              <Button
                id="checkout-click-login-v1"
                className="w-full"
                type="black"
                onClick={handleAuthRoute}
              >
                ورود / ثبت نام
              </Button>
            </AnalyticsWrapper>
          </div>
        </div>
      </PopUpModal>
    </div>
  );
}

export default AuthModal;
